import { Injectable } from '@angular/core';
import * as debug from './debug.service';
import { LocalDb, IClientError } from '../utils/local-db';

@Injectable({ providedIn: 'root' })
export class ErrorDbService extends LocalDb {

	constructor() {
		super();
		debug.log('001 ErrorDbService instantiated');
	}

	async store(body: string): Promise<void> {
		await this.errors.add({ error: body });
		return Promise.resolve();
	}

	async bulkDelete(ids: number[]): Promise<void> {
		await this.errors.bulkDelete(ids);
		return Promise.resolve();
	}

	async deleteItem(ids: number): Promise<void> {
		await this.errors.bulkDelete([ids]);
		return Promise.resolve();
	}

	async getAll(): Promise<IClientError[]> {
		return await this.errors.toArray();
	}
}
